import { readChatBrowserNotifyEnabled } from '@/services/chatBrowserNotificationsPrefs';

export function isChatBrowserNotificationSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    typeof window.Notification === 'function'
  );
}

export function getChatNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!isChatBrowserNotificationSupported()) return 'unsupported';
  return window.Notification.permission;
}

export async function requestChatNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!isChatBrowserNotificationSupported()) return 'unsupported';
  try {
    return await window.Notification.requestPermission();
  } catch {
    return window.Notification.permission;
  }
}

function publicAssetAbsoluteUrl(assetPath: string): string | undefined {
  const pub = (typeof process !== 'undefined' && process.env.PUBLIC_URL
    ? String(process.env.PUBLIC_URL)
    : ''
  ).replace(/\/$/, '');
  const path = `${pub}/${assetPath.replace(/^\/+/, '')}`.replace(/\/{2,}/g, '/');
  if (typeof window !== 'undefined' && window.location?.origin) {
    try {
      return new URL(path, window.location.origin).href;
    } catch {
      return undefined;
    }
  }
  return undefined;
}

/**
 * Показать уведомление о новом сообщении (вызывать только когда уже решили проиграть звук / тот же сценарий).
 * Текст сообщения не передаём — только имя контакта и общая фраза (E2EE).
 * Разрешение Chrome может быть granted; без явного «вкл» в настройках приложения не показываем.
 */
export function showChatIncomingMessageNotification(params: {
  title: string;
  body: string;
  tag: string;
  iconUrl?: string;
  bypassUserPreference?: boolean;
}): boolean {
  if (!isChatBrowserNotificationSupported()) return false;
  if (!params.bypassUserPreference && !readChatBrowserNotifyEnabled()) return false;
  if (window.Notification.permission !== 'granted') return false;

  try {
    const icon =
      params.iconUrl?.trim() ||
      publicAssetAbsoluteUrl('pigeio.png') ||
      publicAssetAbsoluteUrl('logo512.png');
    const n = new window.Notification(params.title, {
      body: params.body,
      tag: params.tag,
      icon,
      badge: icon,
      renotify: true,
    });
    n.onclick = () => {
      try {
        window.focus();
      } catch {
        /* */
      }
      n.close();
    };
    return true;
  } catch {
    /* Safari / ограничения */
    return false;
  }
}
